app.controller("AdminsIndexController", ["$scope", "StSubject", "StaticData", "Administrators", "$uibModal", "$stateParams", "$state",
    function ($scope, StSubject, StaticData, Administrators, $uibModal, $stateParams, $state) {
        $scope.admins = [];
        $scope.totalItems = 0;
        $scope.itemsPerPage = 20;
        $scope.query = $stateParams.query;
        $scope.faculty = $stateParams.faculty;

        loadPage($stateParams.page, function () {
            $scope.currentPage = $stateParams.page;
        });

        StaticData.getItemsByKey("faculties").then(function (faculties) {
            $scope.faculties = [{name: "ფაკულტეტი"}].concat(faculties);
            $scope.facultiesMap = _.keyBy($scope.faculties, '_id');
        });

        $scope.goToPage = function (page) {
            $state.go(".", {page: page});
            // loadPage(page);
        };

        $scope.applyFilter = function () {
            $state.go(".", {
                query: $scope.query,
                faculty: $scope.faculty
            });
        };

        $scope.changePage = function () {
            $scope.goToPage($scope.currentPage);
        };

        function loadPage(page, cb) {
            cb = cb || function () {
                };
            Administrators.list({
                page: page,
                limit: $scope.itemsPerPage,
                faculty: $stateParams.faculty,
                query: $stateParams.query
            }).then(function (data) {
                var adminList = data.docs
                for(var i in adminList){
                    if(!adminList.user) {
                        continue;
                    }
                    if(!adminList[i].user.photo && adminList[i].user.gender == 'male') adminList[i].user.defaultPhoto = "img/male.jpg";
                    if(!adminList[i].user.photo && adminList[i].user.gender == 'female') adminList[i].user.defaultPhoto = "img/female.jpg";
                    else if(!adminList[i].user.photo && !adminList[i].user.gender) adminList[i].user.defaultPhoto = "img/no_image.jpg";
                }

                $scope.admins = adminList;
                $scope.totalItems = data.total;
                cb();
            });
        }

        $scope.add = function () {
            $uibModal.open({
                controller: "AddAdminController",
                templateUrl: _pb + 'sudo/admins/add-admin.html',
                size: "md"
            }).result
                .then(function (result) {
                    loadPage($stateParams.page);
                }, function () {
                });
        };

        $scope.edit = function (admin, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            $uibModal.open({
                controller: "EditAdminController",
                templateUrl: _pb + 'sudo/admins/edit-admin.html',
                size: "md",
                resolve: {
                    admin: function () {
                        return admin;
                    }
                }
            }).result
                .then(function (result) {
                    loadPage($scope.currentPage);
                }, function () {
                });
        };
    }
]);
